<div class="left-container-toolbar">
  @if (isStandardView) {
    <button (click)="createUser()" class="primary" type="button">
      {{ "generic.toolbar.addNew" | translate }}
    </button>
    @if (isMaster) {
      <button (click)="updateAll($event)" class="primary" type="button">
        {{ "generic.toolbar.updateAllFromScd" | translate }}
      </button>
    }
    <button (click)="exportUsers()" class="primary" type="button">
      {{ "generic.buttons.export" | translate }}
    </button>
  }

  @if (isCreateView || isEditView) {
    <button class="primary" type="submit" form="register-form">
      {{ "generic.buttons.save" | translate }}
    </button>
  }

  @if (isInfoView) {
    <button (click)="editUser(selectedItem)" class="primary">
      {{ "generic.buttons.edit" | translate }}
    </button>
    <button (click)="updateUser($event)" class="primary">
      {{ "generic.toolbar.updateScd" | translate }}
    </button>
    <button (click)="deleteUser()" class="danger">
      {{ "generic.buttons.delete" | translate }}
    </button>
  }
</div>
<div class="right-container-toolbar">
  @if (isStandardView) {
    <app-search-bar [(value)]="searchValue" [data]="data" (changeFilter)="changeFilter($event)" [filters]="filters" />
  }
</div>
